import { createPortal } from 'react-dom'
import React from 'react'
import UserRate from '../index'

interface Params {
  id: string;
}

export default function UserRatePortal({ id }: Params) {
  const Root = document.getElementById(id);

  if (!Root) {
    return null
  }

  const userId = Root.getAttribute('data-userId');

  if (!userId) {
    throw new Error('"date-userId" attributes is required')
  }

  return createPortal(<UserRate userId={parseInt(userId, 10)} />, Root)
}
